module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mt-header', {
    attrs: {
      "fixed": "",
      "title": "默认标题+固定置顶",
      "router": "",
      "leftIcontext": "返回"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-gengduo",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "page-header-main"
  }, [_c('mt-header', {
    attrs: {
      "title": "背景色",
      "backgroundColor": "mt-bg-theme"
    }
  }, [_c('router-link', {
    attrs: {
      "slot": "left",
      "to": "/"
    },
    slot: "left"
  }, [_c('span', {
    staticClass: "iconfont icon-keyboardarrowleft"
  })])], 1), _vm._v(" "), _c('mt-header', {
    attrs: {
      "title": "多个按钮",
      "backgroundColor": "mt-bg-warning"
    }
  }, [_c('router-link', {
    attrs: {
      "slot": "left",
      "to": "/"
    },
    slot: "left"
  }, [_c('span', [_c('i', {
    staticClass: "iconfont icon-keyboardarrowleft"
  }), _vm._v("返回")])]), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-close",
    attrs: {
      "slot": "left"
    },
    on: {
      "click": _vm.handleClose
    },
    slot: "left"
  }, [_vm._v("关闭")]), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-zhuantui",
    attrs: {
      "slot": "right"
    },
    on: {
      "click": _vm.alert
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('mt-header', {
    attrs: {
      "title": "左侧仅文字",
      "backgroundColor": "mt-bg-danger"
    }
  }, [_c('router-link', {
    attrs: {
      "slot": "left",
      "to": "/"
    },
    slot: "left"
  }, [_c('span', [_vm._v("返回")])])], 1), _vm._v(" "), _c('mt-header', {
    attrs: {
      "title": "字体16px,高度50px",
      "fontSize": "16px",
      "height": "50px",
      "backgroundColor": "mt-bg-purple"
    }
  }, [_c('router-link', {
    attrs: {
      "slot": "right",
      "to": "/"
    },
    slot: "right"
  }, [_c('span', [_vm._v("分享")])])], 1), _vm._v(" "), _c('mt-header', {
    attrs: {
      "title": "返回跳转",
      "backgroundColor": "mt-bg-primary",
      "to": "/cell",
      "router": "",
      "leftIcontext": "To Cell组件"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-touxiang",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d993a940","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/header.vue
// module id = 530
// module chunks = 0